// extracted by mini-css-extract-plugin
export var numberInputContainer = "_7a-0";
export var startPickingButton = "_7a-1";